// @core/api/endpoints/analytics/delete_saved_query.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/analytics';

/**
 * Delete saved query
 * Deletes a saved analytics query.
 */
export async function DeleteSavedQuery(
  query_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/analytics/saved-queries/:query_id`;
  requestPath = requestPath.replace(':query_id', encodeURIComponent(query_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
